type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'IndicationType'
const nameSource = 'commercial/indicationTypes'
const namePageTitle = 'Linhas de Créditos'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Cadastro',
  to: '/commercial/indicationTypes',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/commercial/indicationTypes/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/commercial/indicationTypes/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Atualizar',
    to: '/commercial/indicationTypes/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
